import { IDisposer } from './Types'

export class NullDisposer implements IDisposer {
  setView() {}

  accept = async () => {}

  reject = () => {}

  rejectAll = () => {}

  get canAcceptChanges() {
    return false
  }

  get canRejectChanges() {
    return false
  }

  get isDispositioning() {
    return false
  }
}
